import { useEffect, useState } from 'react';
import { ButtonHeadless, Modal, TextInput } from '@wajeez-web/components/ui';
import { useDebounce } from '@wajeez-web/components/helpers';
import {
  CollectionComponetsActions,
  useContentDispatch,
  useContentSelector,
} from '@wajeez-web/stores/content';
import { Server } from '@wajeez/wajeez.microservices';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';

interface FlowCollectionComponentsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (
    selectedCollectionComponent:
      | Server.CollectionComponentLookUpOutput
      | undefined
  ) => void;
}

export const FlowCollectionComponentsModal = ({
  isOpen,
  onClose,
  onSubmit,
}: FlowCollectionComponentsModalProps) => {
  const contentDispatch = useContentDispatch();

  const [selectedCollectionComponent, setSelectedCollectionComponent] =
    useState<Server.CollectionComponentLookUpOutput>();

  const collectionComponents = useContentSelector(
    ({ collectionComponents }) =>
      collectionComponents.collectionComponentLookups
  );

  const [setSearchTermDebounced] = useDebounce((data) => {
    contentDispatch(
      CollectionComponetsActions.getCollectionComponentLookupsAsync({
        searchText: data?.value,
      })
    );
  });

  useEffect(() => {
    contentDispatch(
      CollectionComponetsActions.getCollectionComponentLookupsAsync({})
    );
  }, []);

  const renderCollectionComponents = () => {
    return collectionComponents.data.map((cc) => {
      return (
        <div
          key={cc.id}
          className={`w-full py-4 px-3 rounded-md border break-all text-center flex justify-center items-center cursor-pointer ${
            selectedCollectionComponent?.id === cc.id && 'border-primary'
          }`}
          onClick={() => {
            setSelectedCollectionComponent(cc);
          }}
        >
          {cc.referenceName}
        </div>
      );
    });
  };

  return (
    <Modal title="Choose Colllection Component" open={isOpen} onClose={onClose}>
      <div className="w-full h-full">
        <div className="w-full max-w-[300px] px-2">
          <TextInput
            name="collection-component-search"
            label="Search"
            onChange={(name, value) => {
              setSearchTermDebounced({ value });
            }}
          />
        </div>
        <div className="mt-5 px-2 w-full h-[380px] grid grid-cols-3 gap-x-4 gap-y-4 overflow-y-auto">
          {renderCollectionComponents()}
        </div>
        <div className="mt-6 w-full flex justify-end items-center">
          <div className="w-[70px]">
            <ButtonHeadless
              paddingYStyle="py-2"
              isDisabled={!selectedCollectionComponent}
              bgStyle={
                !selectedCollectionComponent ? 'bg-warmGray-300' : 'bg-primary'
              }
              action={() => {
                onSubmit(selectedCollectionComponent);
              }}
            >
              <div className="text-white">
                <ReturnTranslatedText
                  origintext="Choose"
                  text={`buttons.${'Choose'}`}
                />
              </div>
            </ButtonHeadless>
          </div>
        </div>
      </div>
    </Modal>
  );
};
